import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconSize } from '../../../enums/icon.enum';
import { IconComponent } from '../../atoms/icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar-item',
  imports: [CommonModule, RouterModule, IconComponent, TranslateModule],
  templateUrl: './sidebar-item.component.html',
  styleUrl: './sidebar-item.component.scss'
})
export class SidebarItemComponent {
  @Input() icon!: string;
  @Input() label!: string;
  @Input() link!: string;
  @Input() isExpanded = false; // Default is collapsed
  @Input() disableHover = false;

  public IconSize = IconSize;

}
